export const refs = {
  moviesOnInputList: document.querySelector('.movie__gallery'),
  inputEl: document.querySelector('.search-form'),
  pagePreloader: document.getElementById('page-preloader'),
  body: document.querySelector('body'),
  headerUserNoLoginContainer: document.getElementById('div-sign-up'),
  headerLoginBtn: document.querySelector('[login-data-modal-open]'),
  headerSignupBtn: document.querySelector('[signup-data-modal-open]'),
  signupBtnClose: document.querySelector('[signup-data-modal-close]'),
  headerUserLogedinContainer: document.getElementById('div-sign-out'),
  headerUserEmailDiv: document.getElementById('header-useremail-div'),
  headerSignoutBtn: document.querySelector('[signout-data-modal-open]'),
  loginModalCloseBtn: document.querySelector('[login-data-modal-close]'),
  loginModal: document.querySelector('[login-data-modal]'),
  loginForm: document.getElementById('login-form'),
  divLoginEmailError: document.getElementById('loginemail-error-message'),
  divLoginPassError: document.getElementById('loginpassword-error-message'),
  signupModal: document.querySelector('[signup-data-modal]'),
  signupForm: document.getElementById('signup-form'),
  divSignUpError: document.getElementById('signup-error-message'),
  signupBtn: document.querySelector('.signup-modal__button'),
  signupBtnOnLoginModal: document.querySelector('.login-modal__button--signup'),
  policyCheckbox: document.querySelector('[name="policy-checkbox"]'),
  signoutModal: document.querySelector('[signout-data-modal]'),
  topMovieEll: document.querySelector('.swiper-wrapper'),
  scrollUp: document.querySelector('.up-btn__wrapper'),
  scrollUpSvgPath: document.querySelector('.up-btn__svg-path'),
  watchedAddBtn: '',
  modalMovieContent: document.querySelector('.modal-movie__content'),
  watchedGallery: false,
  successModalText: document.querySelector('.success-modal-text'),
  modalSuccess: document.querySelector('[success-data-modal]'),
  modalSuccessCloseBtn: document.querySelector('[success-data-modal-close]'),
  closeModalBtnSignOut: document.querySelector('[signout-data-modal-close]'),
  tagsEl: document.querySelector('#tags-genre'),
  tagEl: document.querySelectorAll('.tag'),
  moviesOnInputList: document.querySelector('.movie__gallery'),
  filterOpenBtn: document.querySelector('.filter'),
  filterBtn: document.querySelector('.filter__btn'),
  filterOpenBtnIcon: document.querySelector('.filter__icon'),
  filterReset: document.querySelector('.filter__reset'),
};
